export const locales = ['en', 'zh-cn'] as const;
export type Locale = (typeof locales)[number];

const dictionaries = {
  en: () =>
    import('../../../dictionaries/en.json').then((module) => module.default),
  'zh-cn': () =>
    import('../../../dictionaries/cn.json').then((module) => module.default),
};

export async function getDictionary(locale: Locale) {
  return dictionaries[locale]();
}
